<template>
	<a-card :bordered="false" class="widget-counter-card" :bodyStyle="{ padding: '20px' }">
		<div class="widget-content">
			<!-- 数据区域 -->
			<div class="widget-data">
				<div class="widget-value" :class="'text-' + status">
					<span v-if="prefix" class="value-prefix">{{ prefix }}</span>
					<span class="value-number">{{ formattedValue }}</span>
					<span v-if="suffix" class="value-suffix">{{ suffix }}</span>
				</div>
				<div class="widget-title">{{ title }}</div>
				<div class="widget-badge" v-if="badge" :class="badgeClass">{{ badge }}</div>
			</div>
			<!-- 图标区域 - 右侧 -->
			<div class="widget-icon" :class="iconClass" v-if="$slots.icon || icon">
				<slot name="icon">
					<span v-html="icon"></span>
				</slot>
			</div>
		</div>
	</a-card>
</template>

<script>
	export default ({
		props: {
			title: {
				type: String,
				default: "",
			},
			value: {
				type: Number,
				default: 0,
			},
			prefix: {
				type: String,
				default: "",
			},
			suffix: {
				type: String,
				default: "",
			},
			icon: {
				type: String,
				default: "",
			},
			status: {
				type: String,
				default: "success",
			},
			badge: {
				type: String,
				default: "",
			},
			badgeStatus: {
				type: String,
				default: "neutral", // success, danger, neutral
			},
		},
		computed: {
			formattedValue() {
				if (this.value === null || this.value === undefined) return '0';
				return this.value.toLocaleString();
			},
			iconClass() {
				return {
					'icon-primary': this.status === 'success' || this.status === 'primary',
					'icon-danger': this.status === 'danger',
					'icon-warning': this.status === 'warning',
				};
			},
			badgeClass() {
				return {
					'badge-success': this.badgeStatus === 'success',
					'badge-danger': this.badgeStatus === 'danger',
					'badge-neutral': this.badgeStatus === 'neutral',
				};
			}
		},
		data() {
			return {
			}
		},
	})
</script>

<style lang="scss" scoped>
.widget-counter-card {
	border-radius: 16px;
	border: 1px solid #E5E7EB;
	box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.1) 0px 1px 2px -1px;
	transition: all 0.2s ease;
	background: #FFFFFF;

	&:hover {
		box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.1) 0px 2px 4px -1px;
	}
}

.widget-content {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-start;
	gap: 16px;
}

.widget-icon {
	width: 48px;
	height: 48px;
	border-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	order: 2;

	&.icon-primary {
		background: rgba(37, 99, 235, 0.1);
		color: #2563EB;
	}

	&.icon-danger {
		background: rgba(239, 68, 68, 0.1);
		color: #EF4444;
	}

	&.icon-warning {
		background: rgba(245, 158, 11, 0.1);
		color: #F59E0B;
	}

	::v-deep svg {
		width: 24px;
		height: 24px;
	}
}

.widget-data {
	flex: 1;
	min-width: 0;
	order: 1;
}

.widget-value {
	font-size: 30px;
	font-weight: 700;
	line-height: 1.2;
	color: #111827;
	font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;

	.value-prefix, .value-suffix {
		font-size: 16px;
		font-weight: 500;
	}

	&.text-success {
		color: #111827;
	}

	&.text-danger {
		color: #111827;
	}

	&.text-warning {
		color: #111827;
	}
}

.widget-title {
	font-size: 14px;
	color: #6B7280;
	margin-top: 4px;
	font-weight: 400;
	font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.widget-badge {
	display: inline-block;
	margin-top: 8px;
	padding: 4px 8px;
	border-radius: 6px;
	font-size: 12px;
	font-weight: 500;
	font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;

	&.badge-success {
		background: rgba(16, 185, 129, 0.1);
		color: #10B981;
	}

	&.badge-danger {
		background: rgba(239, 68, 68, 0.1);
		color: #EF4444;
	}

	&.badge-neutral {
		background: rgba(107, 114, 128, 0.1);
		color: #6B7280;
	}
}
</style>